import React, { useContext } from 'react';
import { NavLink, Link, useParams } from 'react-router-dom';
import Flag from 'react-world-flags'

import { Nav, Image } from 'react-bootstrap';

import AuthenticationContext from 'context/Authentication/AuthenticationContext';
import SidebarContext from 'context/Sidebar/SidebarContext';

export default function Sidebar() {

    const { authenticatedState } = useContext(AuthenticationContext);
    const { sidebarState } = useContext(SidebarContext);

    const { ordersPage, claimsPage, eventsPage, alliesPage, alliesPaymentsPage, approvalsAlliesPage, approvalsContentsPage, approvalsPromotionsPage, customersPage, contentsPage, promotionsPage } = useParams();

    return (
        <div className={!sidebarState.isShow ? "sidebar sidebar-show" : "sidebar"}>
            <div className="sidebar-contain">
                <Link to="/admin/dashboard" className="sidebar-logo pt-3 pb-3" title="Página de inicio de Conecta">
                    <Image src="/logo.png" width="150" />
                    {authenticatedState.user.codigoPais && authenticatedState.user.pais && (
                        <div className="text-right mt-2" title={`Conecta ${authenticatedState.user.pais}`}>
                            <Flag code={authenticatedState.user.codigoPais} height={18} style={{borderRadius: '5px'}} />
                        </div>
                    )}
                </Link>
                <div className="sidebar-content mt-2">
                    <Nav className="nav--sidebar flex-column">
                        <NavLink exact to="/admin/dashboard" className="nav-link pt-3 pb-3" activeClassName="active" title="Resumen">Resumen</NavLink>
                        <NavLink to="/admin/dashboard/orders/page/1" className="nav-link pt-3 pb-3" title="Órdenes" isActive={
                            () => {
                                if (ordersPage) {
                                    return true;
                                }
                            }
                        }>
                            Órdenes
                        </NavLink>
                        <NavLink to="/admin/dashboard/contents/page/1" className="nav-link pt-3 pb-3" title="Contenidos" isActive={
                            () => {
                                if (contentsPage) {
                                    return true;
                                }
                            }
                        }>
                            Contenidos
                        </NavLink>
                        <NavLink to="/admin/dashboard/promotions/page/1" className="nav-link pt-3 pb-3" title="Promociones" isActive={
                            () => {
                                if (promotionsPage) {
                                    return true;
                                }
                            }
                        }>
                            Promociones
                        </NavLink>
                        {authenticatedState.user.role === 'AdministradorPais' || authenticatedState.user.role === 'OperadorPais' ? (
                            <NavLink to="/admin/dashboard/approvals/page/1" className="nav-link pt-3 pb-3" title="Aprobaciones" isActive={
                                () => {
                                    if (eventsPage || approvalsAlliesPage || approvalsContentsPage || approvalsPromotionsPage) {
                                        return true;
                                    }
                                }
                            }>
                                Aprobaciones
                            </NavLink>
                        ) : ('')}
                        <NavLink to="/admin/dashboard/allies/page/1" className="nav-link pt-3 pb-3" title="Proveedores" isActive={
                            () => {
                                if (alliesPage) {
                                    return true;
                                }
                            }
                        }>
                            Proveedores
                        </NavLink>
                        {/*<NavLink to="/admin/dashboard/allies-payments/page/1" className="nav-link pt-3 pb-3" title="Pagos aliados" isActive={
                            () => {
                                if (alliesPaymentsPage) {
                                    return true;
                                }
                            }
                        }>
                            Pagos aliados
                        </NavLink>*/}
                        <NavLink to="/admin/dashboard/customers/page/1" className="nav-link pt-3 pb-3" title="Clientes" isActive={
                            () => {
                                if (customersPage) {
                                    return true;
                                }
                            }
                        }>
                            Clientes
                        </NavLink>
                        <NavLink to="/admin/dashboard/claims/page/1" className="nav-link pt-3 pb-3" title="Reclamos" isActive={
                            () => {
                                if (claimsPage) {
                                    return true;
                                }
                            }
                        }>
                            Reclamos
                        </NavLink>
                    <NavLink to="/admin/dashboard/points" className="nav-link pt-3 pb-3" title="Puntos">Puntos</NavLink>
                    </Nav> 
                    
                </div>
                <div className="sidebar-logout">
                    <Link to="/admin/dashboard/logout" className="btn btn-primary btn-block btn-pill btn-xl btn-icon link-box">
                        <svg className="mr-2" height="28px" viewBox="0 0 24 24" width="28px"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>
                        <span className="text-white font-weight-300">Cerrar sesión</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}
